import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';

import Alert from '@material-ui/lab/Alert';

import CloseIcon from '@material-ui/icons/Close';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    content: {
        margin: theme.spacing(2)
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    button: {
        margin: theme.spacing(1),
        fontWeight: 'bold',
        width: 150
    },
})

class DialogAddComponent extends React.Component {
    constructor() {
        super()
        this.state = {
            input_username: '',
            input_password: '',
            input_checkbox: false,

            error_username: false,
            error_password: false,

            alert: false
        }
    }

    onChangeHandler = event => {
        this.setState({ [event.target.name]: event.target.value })

        if (event.target.name === 'input_username') {
            this.setState({ error_username: false })
        }
        else if (event.target.name === 'input_password') {
            this.setState({ error_password: false })
        }
    }

    onChangeHandler_checkbox = event => {
        this.setState({ input_checkbox: event.target.checked })
    }

    onBlurHandler = event => {
        if (event.target.value === '') {
            if (event.target.name === 'input_username') {
                this.setState({ error_username: true })
            }
            else if (event.target.name === 'input_password') {
                this.setState({ error_password: true })
            }
        }
    }

    submitHandler = () => {
        if (this.state.input_username === '' ||
            this.state.input_password === '') {
            this.setState({
                alert: true,
                alertText: "Please fill in the required input/s."
            })
        }
        else {
            this.props.action(
                this.state.input_username,
                this.state.input_password,
                this.state.input_checkbox
            )
        }
    }

    render() {
        const { classes } = this.props

        return (
            <Dialog onClose={this.props.onClose}
                open={this.props.open}>
                <DialogTitle>
                    Add User
                </DialogTitle>
                <IconButton aria-label="close" className={classes.closeButton}
                    onClick={this.props.onClose}>
                    <CloseIcon />
                </IconButton>

                <DialogContent style={{ overflow: 'hidden' }}>
                    {this.state.alert ?
                        <Alert severity="error">
                            {this.state.alertText}
                        </Alert>
                        :
                        null
                    }
                    <Grid container direction="row" spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="User Name"
                                name="input_username"
                                value={this.state.input_username}
                                onChange={this.onChangeHandler}
                                onBlur={this.onBlurHandler}
                                inputProps={{ maxLength: 50 }}
                                error={this.state.error_username}
                                helperText={this.state.error_username ? 'Username cannot be empty!' : null}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                type="password"
                                fullWidth
                                label="Password"
                                name="input_password"
                                value={this.state.input_password}
                                onChange={this.onChangeHandler}
                                onBlur={this.onBlurHandler}
                                inputProps={{ maxLength: 50 }}
                                error={this.state.error_password}
                                helperText={this.state.error_password ? 'Password cannot be empty!' : null}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="input_checkbox"
                                        checked={this.state.input_checkbox}
                                        onChange={this.onChangeHandler_checkbox}
                                    />
                                }
                                label="Admin Access"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.submitHandler}
                        className={classes.button}
                        variant="contained"
                        color="primary">
                        Add
                    </Button>
                    <Button onClick={this.props.onClose}
                        className={classes.button}
                        variant="contained"
                        color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles, { withTheme: true })(DialogAddComponent);